import { PatientActionsContact } from 'apps/wrapper/src/components/shared/contact/patient-actions/types/patient-info';
import { Contact } from 'apps/wrapper/src/services/api-client/contact-api';
import { AppointmentRequestDetails } from 'apps/wrapper/src/services/appointment/types/appointment-request-details';

export const CreatePatientActionsProps = (apptRequest: AppointmentRequestDetails,
  locationId: number, locationName: string, contact?: Contact): PatientActionsContact => {
  if (contact) return contact;

  return {
    id: apptRequest.patient.id,
    firstName: apptRequest.patient.firstName,
    lastName: apptRequest.patient.lastName,
    cellPhone: apptRequest.patient.phone.replace(/\D/g, ''),
    homePhone: undefined,
    workPhone: undefined,
    email: apptRequest.patient.email,
    location: {
      id: locationId,
      name: locationName
    }
  }
}